import * as types from './types';

const fetchLeadInfo = id => ({ type: types.FETCH_LEAD_INFO, payload: id });
const fetchLeadInfoSuceeded = data => ({ type: types.FETCH_LEAD_INFO_SUCCEEDED, payload: data });
const fetchLeadInfoFailed = error => ({ type: types.FETCH_LEAD_INFO_FAILED, payload: error });

const fetchEmailValidationSucceeded = emailData => ({
  type: types.FETCH_EMAIL_VALIDATION_SUCCEEDED,
  payload: emailData
});

const fetchPhoneValidationSucceeded = phoneData => ({
  type: types.FETCH_PHONE_VALIDATION_SUCCEEDED,
  payload: phoneData
});

const fetchPhoneValidationReset = phoneData => ({
  type: types.FETCH_PHONE_VALIDATION_RESET,
  payload: phoneData
});

const fetchEmailValidationNoData = phoneData => ({
  type: types.FETCH_EMAIL_VALIDATION_NO_DATA,
  payload: phoneData
});

const sendEmail = id => ({ type: types.FETCH_SEND_EMAIL, payload: id });
const sendEmailSuccess = data => ({ type: types.FETCH_SEND_EMAIL_SUCCESS, payload: data });
const sendEmailFailed = error => ({ type: types.FETCH_SEND_EMAIL_ERROR, payload: error });

const updateLeadStatus = id => ({ type: types.UPDATE_LEAD_STATUS, payload: id });
const updateLeadStatusSuceeded = data => ({ type: types.UPDATE_LEAD_STATUS_SUCCEEDED, payload: data });
const updateLeadStatusFailed = error => ({ type: types.UPDATE_LEAD_STATUS_FAILED, payload: error });

const fetchSmartLead = id => ({ type: types.FETCH_SMARTLEAD, payload: id });
const fetchSmartLeadSuceeded = data => ({ type: types.FETCH_SMARTLEAD_SUCCEEDED, payload: data });
const fetchSmartLeadFailed = error => ({ type: types.FETCH_SMARTLEAD_FAILED, payload: error });
const fetchSmartLeadReset = data => ({ type: types.FETCH_SMARTLEAD_SUCCEEDED, payload: data });
const fetchFeedbackReset = data => ({ type: types.FETCH_FEEDBACK_RESET, payload: data });

const fetchScoreLead = id => ({ type: types.FETCH_SCORELEAD, payload: id });
const fetchScoreLeadSuceeded = data => ({ type: types.FETCH_SCORELEAD_SUCCEEDED, payload: data });
const fetchScoreLeadFailed = error => ({ type: types.FETCH_SCORELEAD_FAILED, payload: error });
const fetchScoreLeadNoPosting = data => ({ type: types.FETCH_SCORELEAD_NOPOSTING, payload: data });

const fetchRenterProfile = id => ({ type: types.FETCH_RENTERPROFILE, payload: id });
const fetchRenterProfileSuceeded = data => ({ type: types.FETCH_RENTERPROFILE_SUCCEEDED, payload: data });
const fetchRenterProfileailed = error => ({ type: types.FETCH_RENTERPROFILE_FAILED, payload: error });
const fetchRenterProfileNoPosting = data => ({ type: types.FETCH_RENTERPROFILE_NOPOSTING, payload: data });
const fetchRenterProfileReset = data => ({ type: types.FETCH_RENTERPROFILE_SUCCEEDED, payload: data });

const fetchCustomAnswers = data => ({ type: types.FETCH_CUSTOM_ANSWERS, payload: data });
const fetchCustomAnswerStatus = data => ({ type: types.FETCH_CUSTOM_ANSWER_STATUS, payload: data });
const fetchCustomAnswerReset = () => ({ type: types.FETCH_CUSTOM_ANSWER_RESET });

const fetchRelated = id => ({ type: types.FETCH_RELATED, payload: id });
const fetchRelatedSuceeded = data => ({ type: types.FETCH_RELATED_SUCCEEDED, payload: data });
const fetchRelatedFailed = error => ({ type: types.FETCH_RELATED_FAILED, payload: error });

const showSnackBar = data => ({ type: types.SHOW_SNACKBAR, payload: data });
const hideSnackBar = data => ({ type: types.HIDE_SNACKBAR, payload: data });

const showSnackBarLeadDetail = data => ({ type: types.SHOW_SNACKBAR_LEAD_DETAIL, payload: data });
const hideSnackBarLeadDetail = data => ({ type: types.HIDE_SNACKBAR_LEAD_DETAIL, payload: data });
const fetchMessageAttachmentSuceeded = data => ({ type: types.FETCH_MESSAGEATTACHEMENTS_SUCCEEDED, payload: data });
const fetchMessageAttachment = data => ({ type: types.FETCH_MESSAGEATTACHEMENTS, payload: data });
const setSelectedPhone = data => ({ type: types.SELECTED_PHONE, payload: data });
const fetchLeadsStatus = data => ({ type: types.FETCH_LEADS_ETIQUETAS, payload: data });
const fetchLeadsStatusSucess = data => ({ type: types.FETCH_LEADS_ETIQUETAS_SUCCEEDED, payload: data });
const fetchLeadsChangueStatus = data => ({ type: types.FETCH_LEADS_ETIQUETAS_CHANGUE, payload: data });

export {
  showSnackBarLeadDetail,
  hideSnackBarLeadDetail,
  showSnackBar,
  hideSnackBar,
  fetchEmailValidationSucceeded,
  fetchPhoneValidationSucceeded,
  fetchEmailValidationNoData,
  fetchLeadInfo,
  fetchLeadInfoSuceeded,
  fetchLeadInfoFailed,
  updateLeadStatus,
  updateLeadStatusSuceeded,
  updateLeadStatusFailed,
  fetchSmartLead,
  fetchSmartLeadSuceeded,
  fetchSmartLeadFailed,
  fetchScoreLead,
  fetchScoreLeadSuceeded,
  fetchSmartLeadReset,
  fetchScoreLeadFailed,
  fetchScoreLeadNoPosting,
  fetchRelated,
  fetchRelatedSuceeded,
  fetchRelatedFailed,
  fetchCustomAnswers,
  fetchCustomAnswerStatus,
  fetchCustomAnswerReset,
  fetchRenterProfile,
  fetchRenterProfileSuceeded,
  fetchRenterProfileailed,
  fetchRenterProfileNoPosting,
  fetchRenterProfileReset,
  fetchPhoneValidationReset,
  fetchMessageAttachmentSuceeded,
  fetchMessageAttachment,
  setSelectedPhone,
  fetchFeedbackReset,
  fetchLeadsStatus,
  fetchLeadsStatusSucess,
  sendEmail,
  sendEmailSuccess,
  sendEmailFailed,
  fetchLeadsChangueStatus
};
